import { useRef, useEffect } from 'react';
import { useChatStore } from '../../stores/chatStore';
import ChatMessage from './ChatMessage';
import TypingIndicator from '../common/TypingIndicator';
import LoadingSpinner from '../common/LoadingSpinner';

export default function ChatMessageList() {
  const { messages, isLoadingMessages, isSending } = useChatStore();
  const bottomRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when messages change
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isSending]);

  if (isLoadingMessages) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (messages.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="text-center max-w-md">
          <div className="mb-4">
            <img 
              src="/simplytechwise-icon.png" 
              alt="" 
              aria-hidden="true"
              className="h-16 w-16 mx-auto opacity-70" 
            />
          </div>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">
            Welcome to WiseAssist!
          </h2>
          <p className="text-gray-500 text-lg leading-relaxed">
            I'm here to help you with any tech questions. Just type your question below, 
            or tap the camera icon to share a photo of what you need help with.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="flex-1 overflow-y-auto chat-scroll p-4 sm:p-6"
      role="list"
      aria-label="Chat messages"
    >
      <div className="max-w-3xl mx-auto">
        {messages.map((message) => (
          <ChatMessage key={message.id} message={message} />
        ))}
        
        {isSending && (
          <div className="mb-4">
            <TypingIndicator />
          </div>
        )}
        
        <div ref={bottomRef} />
      </div>
    </div>
  );
}
